import {ApiUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorsExportModal} from 'entities/monitor';
import {buildPortMonitorsExportRequest} from 'features/port/lib/portMonitorsExportRequest';

import PortMonitorFiltersForm from '../PortMonitorsFilters/PortMonitorFiltersForm/PortMonitorFiltersForm';

interface IPortMonitorsExportModalProps {
    open: boolean,
    handleClose: () => void,
}

const PortMonitorsExportModal: React.FC<IPortMonitorsExportModalProps> = ({open, handleClose}) => (
    <MonitorsExportModal
        open={open}
        handleClose={handleClose}
        header={t`Экспорт мониторов портов`}
        path={ApiUrls.PORT_MONITORS_EXPORT}
        FiltersForm={PortMonitorFiltersForm}
        buildRequest={buildPortMonitorsExportRequest}
        countLabel={t`Экспортировано мониторов портов`}
    />
);

export default PortMonitorsExportModal;
